





















































































































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {KeyValuePair} from "@payroll/optimus-common";
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";

@Component({})
export default class StatusesManagementProcessManagementComponent extends AfterFetchComponent {
  @Prop(Object) rowSelected!: any
  @Prop(Boolean) showRemark!: any
  @Prop(Boolean) showPaymentDate!: any
  @Prop(Boolean) showDontSendMassage!: any

  @Action('processesManagementMessages', StoreNamespace.PROCESSES_MANAGEMENT) processesManagementMessages: any
  @Action('approveProcessApplications', StoreNamespace.PROCESSES_MANAGEMENT) approveProcessApplications: any
  @Action('rejectProcessApplication', StoreNamespace.PROCESSES_MANAGEMENT) rejectProcessApplication: any
  @Action('underExaminationProcessApplication', StoreNamespace.PROCESSES_MANAGEMENT) underExaminationProcessApplication: any
  @Action('updateProcessRequestContactInformation', StoreNamespace.PROCESSES) updateProcessRequestContactInformation: any;

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string


  private rejectStatuses: KeyValuePair[] = [];
  private underExaminationStatuses: KeyValuePair[] = [];
  private rejectStatusesSelection: KeyValuePair[] = [];
  private underExaminationStatusesSelection: KeyValuePair[] = [];
  private dontSendMessage: boolean = false
  private remarkDescription: string = '';
  private approveProcessExtraInfo: string = '';
  private mngCompanyPhoneDetails: string = '';
  private privateRemarkDescription: string = '';
  private emptyBody: string = '';
  private problemWithApplication: boolean = false;
  private loadingAfterSubmit: boolean = false;
  private sendExtraText: boolean = false;
  private paymentDate: Date | null = null;

  private isEditingContactInfo: boolean = false;
  private newEmail: string = '';
  private newPhoneNumber: string = '';


  mounted() {
    this.privateRemarkDescription = '';
  }

  isFinalStatus() {
    if (this.rowSelected.requestStatus &&
        (this.rowSelected.requestStatus.value === 3 || this.rowSelected.requestStatus.value === 2)) {
      return true;
    } else {
      return false;
    }
  }

  onManagingCompanyUpdateClick(data: any) {
    if (this.rowSelected.statusManagementDetailsFormData.approveApplicationSelect === 0) {
      this.loadingAfterSubmit = true;
      this.approveProcessRequest([this.rowSelected.id]);
    } else if (this.rowSelected.statusManagementDetailsFormData.approveApplicationSelect === 1) {
      this.loadingAfterSubmit = true;
      this.rejectProcessRequest();
    } else if (this.rowSelected.statusManagementDetailsFormData.approveApplicationSelect === 2) {
      this.loadingAfterSubmit = true;
      this.underExaminationProcessRequest();
    } else {
      return
    }
    this.privateRemarkDescription = '';
    this.dontSendMessage = false;
  }

  private getDateFrom(): Date {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    return yesterday;
  }

  private radioGroupSelectionChanged(selected: any) {
    if (selected === 0) {
      this.underExaminationStatusesSelection = [];
      this.rejectStatusesSelection = [];
    } else if (selected === 1) {
      this.underExaminationStatusesSelection = [];
      this.initRejectOptionsInPopupSelection();
    } else if (selected === 2) {
      this.rejectStatusesSelection = [];
      this.initUnderExaminationReasonInPopupSelection();
    }
  }

  isOtherSection(selected: number) {

    let isOtherSection = false;

    if (selected === 1) {
      if (this.rowSelected.statusManagementDetailsFormData.selectRejectType) {
        if (this.rowSelected.statusManagementDetailsFormData.selectRejectType.description === 'אחר.') {
          isOtherSection = true
        }
      }
    } else if (selected === 2) {
      if (this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType) {
        if (this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType.description === 'אחר.') {
          isOtherSection = true
        }
      }
    }

    return isOtherSection
  }

  showDelayOrReject(): boolean {
    return (this.rowSelected.statusManagementDetailsFormData.approveApplicationSelect === 2
            && this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType
            && this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType.description === 'אחר.')
        || (this.rowSelected.statusManagementDetailsFormData.approveApplicationSelect === 1
            && this.rowSelected.statusManagementDetailsFormData.selectRejectType
            && this.rowSelected.statusManagementDetailsFormData.selectRejectType.description === 'אחר.')
  }

  private initRejectOptionsInPopupSelection() {
    this.rejectStatusesSelection = [...this.rejectStatuses]
  }

  private initUnderExaminationReasonInPopupSelection() {
    this.underExaminationStatusesSelection = [...this.underExaminationStatuses]
  }

  private underExaminationProcessRequest(): void {

    let description: string = this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType.description;
    let additionalDescription: string = this.remarkDescription;
    let descriptionCode: number = Number.parseInt(this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType.value)

    if (this.rowSelected.statusManagementDetailsFormData.selectUnderExaminationType.description === 'אחר.') {
      description = '';
    }

    this.remarkDescription = '';

    this.underExaminationProcessApplication({
      requestorCallback: this,
      requestBody: {
        memberProcessId: this.rowSelected.id,
        description: description,
        additionalDescription: additionalDescription,
        memberProcessMessageKey: descriptionCode,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage
      }
    })
  }

  private rejectProcessRequest(): void {
    let description: string = this.rowSelected.statusManagementDetailsFormData.selectRejectType.description;
    let additionalDescription: string = this.remarkDescription;

    let descriptionCode: number = Number.parseInt(this.rowSelected.statusManagementDetailsFormData.selectRejectType.value)

    if (this.rowSelected.statusManagementDetailsFormData.selectRejectType.description === 'אחר.') {
      description = '';
    }

    this.remarkDescription = '';

    this.rejectProcessApplication({
      requestorCallback: this,
      requestBody: {
        memberProcessId: this.rowSelected.id,
        description: description,
        additionalDescription: additionalDescription,
        memberProcessMessageKey: descriptionCode,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage
      }
    })
  }

  private showSuccessAction() {
    if (!this.problemWithApplication) {
      this.$root.$emit('showAlertNotification', {
        toShow: true,
        message: 'processManagement.requestUpdatedSuccessfully',
        icon: 'checkCircle',
        secondsToDisappear: 3
      })
    }
  }

  private approveProcessRequest(allIds: string[]): void {
    this.approveProcessApplications({
      requestorCallback: this,
      requestBody: {
        memberProcessIds: allIds,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage,
        paymentDate: this.paymentDate
      }
    })
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'processesManagementMessages':
        this.rejectStatuses = data.rejectStatuses
        this.underExaminationStatuses = data.underExaminationStatuses
        this.sendExtraText = data.sendExtraText
        this.approveProcessExtraInfo = data.approveProcessExtraInfo
        this.mngCompanyPhoneDetails = data.phoneDetails
        break;

      case 'approveProcessApplications':
      case 'rejectProcessApplication':
      case 'underExaminationProcessApplication':
        this.onClosePopup();
        this.showSuccessAction();
        this.loadingAfterSubmit = false
        break
      case 'updateProcessRequestContactInformation' :
        this.rowSelected.email = this.newEmail;
        this.rowSelected.phoneNumber = this.newPhoneNumber;
        this.isEditingContactInfo = false;
        this.showSuccessAction();
        break
    }
  }

  onError(messages: string[], code: number, requestName?: string) {
    switch (requestName) {
      case 'approveProcessApplications':
      case 'rejectProcessApplication':
      case 'underExaminationProcessApplication':
        const errorMessage: string = messages[0] ? messages[0] : ''
        this.onClosePopupOnRequestFailed(errorMessage);
        this.loadingAfterSubmit = false
        break
      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  @Watch('rowSelected')
  onMemberProcessIdChanged() {
    if (this.rowSelected) {
      this.processesManagementMessages({requestorCallback: this, pathVariable: this.rowSelected.processType.value})
    }
  }

  onClosePopup() {
    this.$emit("closePopup");
  }

  onClosePopupOnRequestFailed(messageError: string) {
    this.$emit("closePopupOnRequestFailed", messageError);
  }
  get notificationToSendAsMemberWillSee(): string {
    const { rowSelected, mngCompanyName, remarkDescription } = this;

    const formData = rowSelected.statusManagementDetailsFormData;
    const applicationSelect = formData.approveApplicationSelect;

    if (applicationSelect === 0) {
      // Approved loan application
      if (rowSelected.requestStatus.key === 1) {
        return this.createApprovedMessage();
      } else {
        return 'בסטטוס מאשר ראשון לא נשלחת הודעה לעמית.';
      }
    } else if (applicationSelect === 1) {
      // Rejected loan application
      if (!formData.selectRejectType || !formData.selectUnderExaminationType.description) return '';
      return this.createRejectMessage(formData.selectRejectType.description);
    } else if (applicationSelect === 2) {
      // Under examination loan application
      if (!formData.selectUnderExaminationType || !formData.selectUnderExaminationType.description) return '';

      return this.createUnderExaminationMessage(formData.selectUnderExaminationType.description);
    }

    return this.createDefaultMessage();
  }

  private createApprovedMessage(): string {
    const { rowSelected, mngCompanyName } = this;
    return `
    שלום , ${rowSelected.memberName}
    <br>
    בקשתך ל ${rowSelected.processType.description} אושרה.
    <br>
    לעיון בפרטי הבקשה לחץ בקישור שלהלן
    <br>
    <a class="text-primary" target="_blank" href="https://optimus-member.malam-payroll.com/#/my-processes/${mngCompanyName.toLowerCase()}">
      https://optimus-member.malam-payroll.com/#/my-processes/${mngCompanyName.toLowerCase()}
    </a>
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private createUnderExaminationMessage(description: string ): string {
    const { rowSelected, mngCompanyName } = this;
    return `
    שלום , ${rowSelected.memberName}
    <br>
    בקשתך ל${rowSelected.processType.description} ממתינה להשלמת נתונים חסרים.
    <br>
    בהתאם לפירוט להלן:
    <br>
    ${this.getSelectTypeDescription(description ? description : '')}
    <br>
    לבירורים נוספים ניתן לפנות ${this.mngCompanyPhoneDetails}
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private createRejectMessage(description: string ): string {
    const { rowSelected } = this;
    return `
    שלום , ${rowSelected.memberName}
    <br>
    בקשתך ל${rowSelected.processType.description} נדתחתה.
    <br>
    בהתאם לפירוט להלן:
    <br>
    ${this.getSelectTypeDescription(description)}
    <br>
    לבירורים נוספים ניתן לפנות ${this.mngCompanyPhoneDetails}
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private getSelectTypeDescription(description: string): string {
    if (description.includes('אחר')) {
      return this.remarkDescription
          ? this.remarkDescription.replace(/\n/g, '<br>')
          : '<b>{**תוכן ההודעה**}</b>';
    }
    return description;
  }

  private createDefaultMessage(): string {
    const { rowSelected } = this;

    return `
    שלום , ${rowSelected.memberName}
    <br>
    בקשתך ל ${rowSelected.processType ? rowSelected.processType.description : ''}.
    <br>
    **תוכן ההודעה**
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  startEditingContact() {
    this.isEditingContactInfo = true;
    this.newEmail = this.rowSelected.email;
    this.newPhoneNumber = this.rowSelected.phoneNumber;
  }

  cancelEditingContact() {
    this.isEditingContactInfo = false;
  }

  saveContactInfo() {
    const body = {
      id: this.rowSelected.id,
      email: this.newEmail,
      phoneNumber: this.newPhoneNumber
    }

    this.updateProcessRequestContactInformation({
      requestorCallback: this,
      requestBody: body
    });
  }
}
